import type { GridApiPremium, GridAutosizeOptions } from "@mui/x-data-grid-premium";
import type { DependencyList, RefObject } from "react";
import { useEffect } from "react";

const autosizeOptions: GridAutosizeOptions = {
  includeOutliers: true,
  includeHeaders: true,
};

const useAutosizeColumns = (
  apiRef: RefObject<GridApiPremium | null> | undefined,
  deps: DependencyList,
  excludedColumns?: RefObject<ReadonlySet<string>>
) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      const api = apiRef?.current;
      if (!api) {
        return;
      }
      const columns = api
        .getAllColumns()
        .map(({ field }) => field)
        .filter((field) => !excludedColumns?.current.has(field));
      if (columns.length > 0) {
        void api.autosizeColumns({ ...autosizeOptions, columns });
      }
    }, 10);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, deps);

  return { autosizeOptions };
};

export default useAutosizeColumns;
